// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../../utils/CSS.bs.js";
import * as Category$Showside from "../../types/Category.bs.js";
import * as RouterProvider$Showside from "../../context/RouterProvider.bs.js";
import * as SectionContent$Showside from "../SectionContent.bs.js";
import * as ViewportContext$Showside from "../../context/ViewportContext.bs.js";
import * as NavMenu__Context$Showside from "./NavMenu__Context.bs.js";
import * as EntrypointContext$Showside from "../../context/EntrypointContext.bs.js";
import * as FiltersPanel_Lazy$Showside from "../FiltersPanel_Lazy.bs.js";
import * as NavMenu__Breadcrumbs$Showside from "./NavMenu__Breadcrumbs.bs.js";
import * as ConfigurationProvider$Showside from "../../context/ConfigurationProvider.bs.js";
import * as FiltersFloatingButton$Showside from "../FiltersFloatingButton.bs.js";
function NavMenu__PLPContent(Props) {
  var category = Props.category;
  var path = Props.path;
  var link = Props.link;
  var scrollableContainerRef = Props.scrollableContainerRef;
  var ctx = NavMenu__Context$Showside.use(undefined);
  var match = ViewportContext$Showside.use(undefined);
  var match$1 = ConfigurationProvider$Showside.use(undefined);
  var match$2 = EntrypointContext$Showside.use(undefined);
  var toggleFiltersPanel = match$2.toggleFiltersPanel;
  var match$3 = RouterProvider$Showside.useRouter(undefined);
  var isFullPLPEnabled = match.isMobile && match$1.config.settings.filtersEnabled;
  var layout = React.useMemo(function () {
    return {
      TAG: /* GridLayout */1,
      _0: {
        columns: Category$Showside.Layout.getColumns(category.listPageActiveLayout),
        gap: Category$Showside.Layout.getGap(category.listPageActiveLayout),
        maxRows: isFullPLPEnabled ? undefined : Belt_Option.orElse(Belt_Option.keep(Category$Showside.Layout.getMaxRows(category.userSelectedLayout), function (maxRows) {
          return maxRows > 2;
        }), 2),
        maxWidth: undefined,
        padding: undefined,
        pattern: undefined
      }
    };
  }, [category.listPageActiveLayout, category.userSelectedLayout, isFullPLPEnabled]);
  var match$4 = Category$Showside.ExternalConnection.getConnection(category);
  var tmp;
  if (match$4 !== undefined && typeof match$4 === "number") {
    switch (match$4) {
      case /* History */0:
        tmp = /* History */3;
        break;
      case /* Favorites */1:
        tmp = /* Favorites */2;
        break;
      case /* StoreCart */2:
        tmp = /* StoreCart */4;
        break;
    }
  } else {
    tmp = /* Products */0;
  }
  var tmp$1 = {
    path: path,
    layout: layout,
    className: CSS$Showside.prefix("sticky top-0 -mt-8 -mb-4 pt-8 pb-6 z-10 bg-main")
  };
  if (link !== undefined) {
    tmp$1.link = Caml_option.valFromOption(link);
  }
  var match$5 = Category$Showside.ExternalConnection.getStoreCategoryConnection(category);
  return React.createElement(React.Fragment, undefined, React.createElement("div", {
    className: CSS$Showside.prefix("relative z-0")
  }, React.createElement(SectionContent$Showside.make, {
    index: 1,
    preferredContentType: tmp,
    category: category,
    layout: layout,
    scrollableContainerRef: scrollableContainerRef,
    forcedOpenLink: function (param) {
      return /* ForceAllCards */0;
    },
    enableFirstCard: false,
    enableInlineMedia: true,
    customTitle: React.createElement(NavMenu__Breadcrumbs$Showside.make, tmp$1)
  })), isFullPLPEnabled && match$5 !== undefined ? React.createElement(React.Fragment, undefined, React.createElement(FiltersFloatingButton$Showside.make, {
    position: "sticky",
    onClick: function (param) {
      Curry._1(toggleFiltersPanel, undefined);
    }
  }), React.createElement(FiltersPanel_Lazy$Showside.make, {
    connection: match$5,
    panelSize: /* FullWidth */3,
    isOpen: match$2.isMobileFiltersOpen,
    fullscreen: true,
    enabledSort: true,
    appliedFilters: match$3.productFilters,
    appliedSort: match$3.productSort,
    zIndex: ctx.zIndex
  })) : null);
}
NavMenu__PLPContent.displayName = "NavMenu__PLPContent";
var make = React.memo(NavMenu__PLPContent);
export { make };
/* make Not a pure module */